import React from 'react';
import { observer } from 'mobx-react';
import { ModalStore } from 'ui/base/modal';
import { ButtonClickEvent } from 'ui/base/types';
import { StandardPage } from 'ui/base/page/standard_page';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './intercept_tuning.module.css';
import Messages from './intercept_tuning_messages';

export type ModalStyles = {
  modal: string;
  modalHeader: string;
  modalBig: string;
  modalLarge: string;
  modalLargest: string;
  modalHeaderTitleText: string;
  modalHeaderHelp: string;
  modalHeaderClose: string;
  modalContent: string;
};

export const themedStyles: ThemedStyles<ModalStyles> = {
  [Theme.DAYLIGHT]: {
    modal: baseStyles.modal,
    modalBig: baseStyles.modalBig,
    modalLarge: baseStyles.modalLarge,
    modalLargest: baseStyles.modalLargest,
    modalHeader: baseStyles.modalHeader,
    modalHeaderTitleText: baseStyles.daylightModalHeaderTitleText,
    modalHeaderHelp: baseStyles.daylightModalHeaderHelp,
    modalHeaderClose: baseStyles.daylightModalHeaderClose,
    modalContent: baseStyles.daylightModalContent,
  },
  [Theme.MIDNIGHT]: {
    modal: baseStyles.modal,
    modalBig: baseStyles.modalBig,
    modalLarge: baseStyles.modalLarge,
    modalLargest: baseStyles.modalLargest,
    modalHeader: baseStyles.modalHeader,
    modalHeaderTitleText: baseStyles.midnightModalHeaderTitleText,
    modalHeaderHelp: baseStyles.midnightModalHeaderHelp,
    modalHeaderClose: baseStyles.midnightModalHeaderClose,
    modalContent: baseStyles.midnightModalContent,
  },
};

type EnablePhysicalInterceptInfoModalProps = {
  store: ModalStore;
};
export const EnablePhysicalInterceptInfoModal = observer(({ store }: EnablePhysicalInterceptInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.enablePhysicalInterceptInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.enablePhysicalInterceptInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type EnableUnicastSpoofingInfoModalProps = {
  store: ModalStore;
};
export const EnableUnicastSpoofingInfoModal = observer(({ store }: EnableUnicastSpoofingInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.enableUnicastSpoofingInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.enableUnicastSpoofingInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type UseUnicastRequestInfoModalProps = {
  store: ModalStore;
};
export const UseUnicastRequestInfoModal = observer(({ store }: UseUnicastRequestInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.useUnicastRequestInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.useUnicastRequestInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type UseUnicastResponseInfoModalProps = {
  store: ModalStore;
};
export const UseUnicastResponseInfoModal = observer(({ store }: UseUnicastResponseInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.useUnicastResponseInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.useUnicastResponseInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type RedirectInternetWithUnicastInfoModalProps = {
  store: ModalStore;
};
export const RedirectInternetWithUnicastInfoModal = observer(({ store }: RedirectInternetWithUnicastInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.redirectInternetWithUnicastInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.redirectInternetWithUnicastInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type RedirectInternalWithUnicastInfoModalProps = {
  store: ModalStore;
};
export const RedirectInternalWithUnicastInfoModal = observer(({ store }: RedirectInternalWithUnicastInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.redirectInternalWithUnicastInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.redirectInternalWithUnicastInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type EnableBroadcastSpoofingInfoModalProps = {
  store: ModalStore;
};
export const EnableBroadcastSpoofingInfoModal = observer(({ store }: EnableBroadcastSpoofingInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.enableBroadcastSpoofingInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.enableBroadcastSpoofingInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type UseBroadcastRequestInfoModalProps = {
  store: ModalStore;
};
export const UseBroadcastRequestInfoModal = observer(({ store }: UseBroadcastRequestInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.useBroadcastRequestInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.useBroadcastRequestInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type UseBroadcastResponseInfoModalProps = {
  store: ModalStore;
};
export const UseBroadcastResponseInfoModal = observer(({ store }: UseBroadcastResponseInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.useBroadcastResponseInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.useBroadcastResponseInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type SpoofGatewayWithBroadcastInfoModalProps = {
  store: ModalStore;
};
export const SpoofGatewayWithBroadcastInfoModal = observer(({ store }: SpoofGatewayWithBroadcastInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.spoofGatewayWithBroadcastInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.spoofGatewayWithBroadcastInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type SpoofHostsWithBroadcastInfoModalProps = {
  store: ModalStore;
};
export const SpoofHostsWithBroadcastInfoModal = observer(({ store }: SpoofHostsWithBroadcastInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.spoofHostsWithBroadcastInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.spoofHostsWithBroadcastInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});

type MasqueradeEgressInfoModalProps = {
  store: ModalStore;
};
export const MasqueradeEgressInfoModal = observer(({ store }: MasqueradeEgressInfoModalProps) => {
  const styles = useStyles(themedStyles);

  const onClose = React.useCallback((event: ButtonClickEvent) => {
    event.stopPropagation();
    store.hideModal();
  }, [store]);

  return(
    <div className={styles.modal}>
      <StandardPage>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderHelp}/>
          <div className={styles.modalHeaderTitleText}>
            {Messages.masqueradeEgressInfoTitle()}
          </div>
          <button className={styles.modalHeaderClose} onClick={onClose}/>
        </div>
        <div className={styles.modalContent}>
          {Messages.masqueradeEgressInfoDetails()}
        </div>
      </StandardPage>
    </div>
  );
});
